type Row={label:string;value:string};
type Sheet={nation:string;aliases:string[];sections:Array<{title:string;rows:Row[]}>};
const rows=(source:string):Row[]=>source.trim().split("\n").filter(Boolean).map(line=>{const split=line.indexOf("|");return split<0?{label:line.trim(),value:""}:{label:line.slice(0,split).trim(),value:line.slice(split+1).trim()};});
const sheet=(nation:string,aliases:string[],sections:Record<string,string>):Sheet=>({nation,aliases,sections:Object.entries(sections).map(([title,source])=>({title,rows:rows(source)}))});

const nationSheetPayload={schema_version:2,sheets:[
sheet("Timocrazia dei Platani",["platani","timocrazia dei platani"],{
 "Quadro generale":`Abitanti|100.0k
Data|luglio -955
Stabilità|100.0 (0.0)
Denaro|73.88 milioni (-1.02 mln)
Tassazione|17.0%`,
 "Tecnologie":`Militare|2.05
Risorse|1.85
Industria|1.74
Logistica|2.52
Medica|2.03
Punti Progresso|124.32 (+6.0)
Ricerca|2.5`,
 "Risorse":`Viveri|-101.0t (-99.5t)
Oro|0.95t (+0.04t)
Argento|35.9t (+1.47t)
Ferro|6.93kt (+155.0t)
Metalli|21.6kt (+476.0t)
Legname|62.9kt (+262.0t)
Fibre tessili|10.4kt (+233.0t)
Rame|1.02kt (+22.9t)
Stagno|102.0t (+2.29t)
Sale|24.9kt (+555.0t)`,
 "Strutture":`Fattorie|1270/2080
Miniera d'oro|1/1
Miniera d'argento|1/2
Miniere di ferro|9/13
Miniere di metalli|5/7
Falegnamerie|13/41
Filaii|7/28
Miniere di rame|10/22
Miniere di stagno|10/13
Saline|8/84`,
 "Prodotti":`Tessuti|0.0t (0)
Armi|315.0t (+15.7t)
Artigianato|0.0t (0)
Bronzo|586.0t (+13.1t)
Ferro lavorato|1.06kt (+23.6t)`,
 "Industrie":`Armerie|3
Industrie tessili|18
Botteghe artigianali|15
Fucine|7
Fonderie di bronzo|4
Costo Stocaggio|1.298mln`,
 "Infrastrutture e servizi":`Campi di addestramento|1 (4.5k/anno)
Cantieri navali|1 (1.74)
Arsenali|1 (1.74)
Capacità infrastrutture|59.6kt (76%)
Manodopera usata in totale|49.09%`,
 "Bisogni della popolazione":`SUSSISTENZA|67.3% sazio · -53.9kt viveri
RISCALDAMENTO|100.0% sazio · -8.98kt legname
ABBIGLIAMENTO|43.6% sazio · -783.0t tessuti
CONSUMISMO|50.9% sazio · -1.83kt artigianato
Soddisfazione media nazionale|65.4%`,
 "Esercito":`Fanti|87
Cavalieri|52
Navi da guerra|1
Riservisti|1.93k
Paga data|1.1 milioni (100%)`
}),
sheet("Morrani",["morrani"],{
 "Quadro generale":`Abitanti|98.7k
Data|luglio -955
Stabilità|100.0 (0.0)
Denaro|-76.45 milioni (-3.86 mln)
Tassazione|27.0%`,
 "Tecnologie":`Militare|2.04
Risorse|1.81
Industria|1.7
Logistica|2.5
Medica|2
Punti Progresso|58.23 (+2.3)
Ricerca|1.5411`,
 "Risorse":`Viveri|-622.0t (-616.0t)
Oro|0.94t (+0.04t)
Argento|35.3t (+1.44t)
Ferro|6.58kt (+136.0t)
Metalli|20.2kt (+444.0t)
Legname|45.9kt (-435.0t)
Fibre tessili|7.96kt (+108.0t)
Rame|1.01kt (+22.3t)
Stagno|101.0t (+2.23t)
Sale|24.6kt (+542.0t)`,
 "Strutture":`Fattorie|1255/2116
Miniera d'oro|1/1
Miniera d'argento|1/1
Miniere di ferro|9/18
Miniere di metalli|5/7
Falegnamerie|13/26
Filaii|7/29
Miniere di rame|10/10
Miniere di stagno|10/7
Saline|8/115`,
 "Prodotti":`Tessuti|0.0t (0)
Armi|-67.1t (-3.35t)
Artigianato|0.0t (0)
Bronzo|426.0t (+5.1t)
Ferro lavorato|1.05kt (+23.1t)`,
 "Industrie":`Armerie|3
Industrie tessili|25
Botteghe artigianali|18
Fucine|7
Fonderie di bronzo|4
Costo Stocaggio|1.079mln`,
 "Infrastrutture e servizi":`Campi di addestramento|3 (13.5k/anno)
Cantieri navali|3 (5.1)
Arsenali|3 (5.1)
Capacità infrastrutture|59.6kt (78%)
Manodopera usata in totale|52.53%`,
 "Bisogni della popolazione":`SUSSISTENZA|65.7% sazio · -51.9kt viveri
RISCALDAMENTO|100.0% sazio · -8.65kt legname
ABBIGLIAMENTO|61.4% sazio · -1.06kt tessuti
CONSUMISMO|61.9% sazio · -2.14kt artigianato
Soddisfazione media nazionale|72.2%`,
 "Esercito":`Fanti|357
Cavalieri|322
Navi da guerra|3
Riservisti|1.93k
Paga data|4.6 milioni (100%)`
}),
sheet("Russystiani",["russystiani"],{
 "Quadro generale":`Abitanti|77.9k
Data|luglio -955
Stabilità|100.0 (0.0)
Denaro|11.85 milioni (-1.55 mln)
Tassazione|18.0%`,
 "Tecnologie":`Militare|1.4
Risorse|1.5
Industria|1.5
Logistica|1.4
Medica|1.3
Punti Progresso|83.89 (+4.2)
Ricerca|3.3557`,
 "Risorse":`Viveri|-87.0t (-86.1t)
Oro|1.51t (+0.05t)
Argento|56.8t (+1.91t)
Ferro|5.04kt (+85.5t)
Metalli|25.8kt (+567.0t)
Legname|179.0kt (+2.26kt)
Fibre tessili|11.7kt (+172.0t)
Rame|546.0t (+12.0t)
Sale|14.3kt (+315.0t)`,
 "Strutture":`Fattorie|1350/2363
Miniera d'oro|2/2
Miniera d'argento|2/3
Miniere di ferro|15/33
Miniere di metalli|9/12
Falegnamerie|22/42
Filaii|12/30
Miniere di rame|12/15
Miniere di stagno|10/18
Saline|7/92`,
 "Prodotti":`Tessuti|0.0t (0)
Armi|2.49kt (+54.8t)
Artigianato|18.5kt (+860.0t)
Bronzo|-40.5t (-13.5t)
Ferro lavorato|373.0t (+8.2t)`,
 "Industrie":`Armerie|7
Industrie tessili|29
Botteghe artigianali|26
Fucine|11
Fonderie di bronzo|4
Costo Stocaggio|2.575mln`,
 "Infrastrutture e servizi":`Campi di addestramento|2 (9.0k/anno)
Arsenali|1 (1.5)
Capacità infrastrutture|70.2kt (109%)
Manodopera usata in totale|71.09%`,
 "Bisogni della popolazione":`SUSSISTENZA|59.6% sazio · -37.1kt viveri
RISCALDAMENTO|100.0% sazio · -5.84kt legname
ABBIGLIAMENTO|93.0% sazio · -1.09kt tessuti
CONSUMISMO|80.0% sazio · -1.87kt artigianato
Soddisfazione media nazionale|83.1%`,
 "Esercito":`Fanti|60
Cavalieri|45
Riservisti|1.23k
Paga data|0.4 milioni (100%)`
}),
sheet("Regno Lumivire",["lumiviri","lumivire","regno lumivire"],{
 "Quadro generale":`Abitanti|105.0k
Data|luglio -955
Stabilità|100.0 (0.0)
Denaro|13.5 milioni (+0.88 mln)
Tassazione|25.0%`,
 "Tecnologie":`Militare|1.85
Risorse|1.71
Industria|1.8
Logistica|2.2
Medica|1.9
Punti Progresso|67.8 (+3.4)
Ricerca|2.26`,
 "Risorse":`Viveri|-67.6t (-67.0t)
Oro|1.37t (+0.07t)
Argento|114.0t (+2.72t)
Ferro|4.52kt (-61.5t)
Metalli|28.6kt (+628.0t)
Legname|-382.0kt (+14.0kt)
Fibre tessili|14.2kt (+181.0t)
Rame|809.0t (+12.5t)
Stagno|63.8t (+0.39t)
Sale|27.7kt (+897.0t)`,
 "Strutture":`Fattorie|1595/1970
Miniera d'oro|2/2
Miniera d'argento|2/3
Miniere di ferro|15/24
Miniere di metalli|7/9
Falegnamerie|26/40
Filaii|14/38
Miniere di rame|12/19
Miniere di stagno|11/16
Saline|14/59`,
 "Prodotti":`Tessuti|8.09kt (+237.0t)
Armi|640.0t (+32.0t)
Artigianato|22.3kt (+847.0t)
Bronzo|5.4t (-13.5t)
Ferro lavorato|1.07kt (+6.79t)`,
 "Industrie":`Armerie|15
Industrie tessili|46
Botteghe artigianali|30
Fucine|20
Fonderie di bronzo|5
Costo Stocaggio|1.081mln`,
 "Infrastrutture e servizi":`Campi di addestramento|1 (4.5k/anno)
Cantieri navali|2 (3.6)
Arsenali|1 (1.8)
Capacità infrastrutture|56.1kt (52%)
Manodopera usata in totale|70.29%`,
 "Bisogni della popolazione":`SUSSISTENZA|74.7% sazio · -62.5kt viveri
RISCALDAMENTO|0.0% sazio · Nessun consumo
ABBIGLIAMENTO|100.0% sazio · -1.83kt tessuti
CONSUMISMO|80.0% sazio · -2.93kt artigianato
Soddisfazione media nazionale|63.7%`,
 "Esercito":`Fanti|382
Cavalieri|35
Riservisti|25.0k
Paga data|1.1 milioni (100%)`
}),sheet("Repubblica Teucride",["teucride","repubblica teucride"],{
 "Quadro generale":`Abitanti|116.0k
Data|luglio -955
Stabilità|100.0 (0.0)
Denaro|-44.74 milioni (-4.6 mln)
Tassazione|20.0%`,
 "Tecnologie":`Militare|2
Risorse|1.9
Industria|1.7
Logistica|2.5
Medica|2
Punti Progresso|76.29 (+3.8)
Ricerca|2.543`,
 "Risorse":`Viveri|-680.0t (-674.0t)
Oro|0.62t (+0.03t)
Argento|47.4t (+2.41t)
Ferro|2.35kt (+29.6t)
Metalli|17.6kt (+398.0t)
Legname|356.0kt (+16.6kt)
Fibre tessili|17.5kt (+723.0t)
Rame|526.0t (+21.2t)
Stagno|22.2t (+0.6t)
Sale|31.5kt (+1.02kt)`,
 "Strutture":`Fattorie|2145/2390
Miniera d'oro|1/1
Miniera d'argento|2/2
Miniere di ferro|11/14
Miniere di metalli|5/7
Falegnamerie|34/44
Filaii|19/28
Miniere di rame|14/24
Miniere di stagno|12/24
Saline|18/100`,
 "Prodotti":`Tessuti|0.0t (0)
Armi|364.0t (+13.5t)
Artigianato|0.0t (0)
Bronzo|274.0t (-2.55t)
Ferro lavorato|1.51kt (+46.0t)`,
 "Industrie":`Armerie|4
Industrie tessili|29
Botteghe artigianali|26
Fucine|10
Fonderie di bronzo|5
Costo Stocaggio|4.276mln`,
 "Infrastrutture e servizi":`Campi di addestramento|1 (4.5k/anno)
Cantieri navali|1 (1.7)
Arsenali|1 (1.7)
Capacità infrastrutture|59.6kt (48%)
Manodopera usata in totale|73.81%`,
 "Bisogni della popolazione":`SUSSISTENZA|80.1% sazio · -74.5kt viveri
RISCALDAMENTO|100.0% sazio · -10.5kt legname
ABBIGLIAMENTO|59.0% sazio · -1.23kt tessuti
CONSUMISMO|74.0% sazio · -3.09kt artigianato
Soddisfazione media nazionale|78.3%`,
 "Esercito":`Fanti|587
Cavalieri|352
Riservisti|1.93k
Paga data|4.0 milioni (100%)`
}),
sheet("Estèrling",["esterling","estèrling"],{
 "Quadro generale":`Abitanti|75.8k
Data|luglio -955
Stabilità|100.0 (0.0)
Denaro|87.87 milioni (-0.72 mln)
Tassazione|19.0%`,
 "Tecnologie":`Militare|1.42
Risorse|1.3
Industria|1.6
Logistica|1.9
Medica|1.7
Punti Progresso|88.8 (+1.8)
Ricerca|1.82`,
 "Risorse":`Viveri|-73.4t (-72.7t)
Oro|1.4t (+0.05t)
Argento|52.8t (+1.82t)
Ferro|2.52kt (+55.4t)
Metalli|19.1kt (+421.0t)
Legname|92.8kt (+1.77kt)
Fibre tessili|9.6kt (+211.0t)
Rame|264.0t (+5.8t)
Stagno|26.4t (+0.58t)
Sale|15.6kt (+343.0t)`,
 "Strutture":`Fattorie|1300/2302
Miniera d'oro|2/2
Miniera d'argento|2/3
Miniere di ferro|11/18
Miniere di metalli|7/9
Falegnamerie|18/45
Filaii|11/28
Miniere di rame|15/30
Miniere di stagno|15/18
Saline|8/91`,
 "Prodotti":`Tessuti|0.0t (+0.0t)
Armi|1.23kt (+27.2t)
Artigianato|0.0t (0)
Bronzo|1.2kt (+26.4t)
Ferro lavorato|1.29kt (+28.3t)`,
 "Industrie":`Armerie|4
Industrie tessili|20
Botteghe artigianali|14
Fucine|8
Fonderie di bronzo|5
Costo Stocaggio|1.438mln`,
 "Infrastrutture e servizi":`Campi di addestramento|1 (4.5k/anno)
Cantieri navali|1 (1.6)
Arsenali|1 (1.6)
Capacità infrastrutture|31.6kt (57%)
Manodopera usata in totale|68.37%`,
 "Bisogni della popolazione":`SUSSISTENZA|56.2% sazio · -34.1kt viveri
RISCALDAMENTO|100.0% sazio · -5.49kt legname
ABBIGLIAMENTO|72.8% sazio · -800.0t tessuti
CONSUMISMO|71.3% sazio · -1.57kt artigianato
Soddisfazione media nazionale|75.1%`,
 "Esercito":`Fanti|118
Cavalieri|38
Riservisti|1.75k
Paga data|0.4 milioni (100%)`
}),
sheet("Il clan della Carpa",["clan della carpa","il clan della carpa"],{
 "Quadro generale":`Abitanti|72.5k
Data|luglio -955
Stabilità|100.0 (0.0)
Denaro|-57.58 milioni (-5.47 mln)
Tassazione|24.0%`,
 "Tecnologie":`Militare|1.5
Risorse|1.7
Industria|1.6
Logistica|1.5
Medica|1.4
Punti Progresso|248.4 (+4.8)
Ricerca|1.6`,
 "Risorse":`Viveri|-135.0t (-134.0t)
Oro|0.26t (+0.02t)
Argento|9.97t (+0.88t)
Ferro|2.2kt (+48.3t)
Metalli|15.8kt (+348.0t)
Legname|457.0kt (+9.72kt)
Fibre tessili|10.4kt (+229.0t)
Rame|555.0t (+12.2t)
Stagno|55.5t (+1.22t)
Sale|5.66kt (+124.0t)`,
 "Strutture":`Fattorie|1300/1916
Miniera d'oro|1/2
Miniera d'argento|1/2
Miniere di ferro|12/23
Miniere di metalli|6/8
Falegnamerie|27/58
Filaii|8/29
Miniere di rame|8/16
Miniere di stagno|8/23
Saline|3/62`,
 "Prodotti":`Tessuti|0.0t (-0.0t)
Armi|2.68kt (+59.0t)
Artigianato|0.0t (0)
Bronzo|109.0t (+2.4t)
Ferro lavorato|-420.0t (-9.24t)`,
 "Industrie":`Armerie|8
Industrie tessili|9
Botteghe artigianali|9
Fucine|10
Fonderie di bronzo|2
Costo Stocaggio|4.943mln`,
 "Infrastrutture e servizi":`Campi di addestramento|3 (13.5k/anno)
Arsenali|1 (1.6)
Capacità infrastrutture|43.9kt (73%)
Manodopera usata in totale|69.98%`,
 "Bisogni della popolazione":`SUSSISTENZA|56.7% sazio · -32.9kt viveri
RISCALDAMENTO|100.0% sazio · -5.99kt legname
ABBIGLIAMENTO|30.1% sazio · -360.0t tessuti
CONSUMISMO|42.1% sazio · -1.01kt artigianato
Soddisfazione media nazionale|57.2%`,
 "Esercito":`Fanti|145
Cavalieri|70
Riservisti|2.81k
Paga data|0.8 milioni (100%)`
}),
sheet("Il popolo degli Arkadi",["arkadi","popolo degli arkadi","il popolo degli arkadi"],{
 "Quadro generale":`Abitanti|99.1k
Data|luglio -955
Stabilità|100.0 (0.0)
Denaro|61.82 milioni (-1.11 mln)
Tassazione|25.0%`,
 "Tecnologie":`Militare|1.2
Risorse|1.9
Industria|1.2
Logistica|1.7
Medica|1.4
Punti Progresso|103.7 (+1.4)
Ricerca|1.4`,
 "Risorse":`Viveri|-58.0t (-57.4t)
Oro|3.66t (+0.08t)
Argento|137.0t (+3.02t)
Ferro|4.93kt (+163.0t)
Metalli|22.7kt (+499.0t)
Legname|224.0kt (+6.71kt)
Fibre tessili|24.1kt (+529.0t)
Rame|409.0t (+9.0t)
Stagno|-2.28t (-0.05t)
Sale|45.4kt (+998.0t)`,
 "Strutture":`Fattorie|1200/1914
Miniera d'oro|2/2
Miniera d'argento|2/3
Miniere di ferro|7/19
Miniere di metalli|5/7
Falegnamerie|14/35
Filaii|9/30
Miniere di rame|6/6
Miniere di stagno|5/10
Saline|14/125`,
 "Prodotti":`Tessuti|0.0t (0)
Armi|1.19kt (+26.4t)
Artigianato|0.0t (0)
Bronzo|246.0t (+5.4t)
Ferro lavorato|-717.0t (-16.0t)`,
 "Industrie":`Armerie|5
Industrie tessili|16
Botteghe artigianali|17
Fucine|6
Fonderie di bronzo|4
Costo Stocaggio|3.233mln`,
 "Infrastrutture e servizi":`Campi di addestramento|1 (4.5k/anno)
Cantieri navali|2 (2.4)
Arsenali|1 (1.2)
Capacità infrastrutture|66.7kt (85%)
Manodopera usata in totale|48.74%`,
 "Bisogni della popolazione":`SUSSISTENZA|65.9% sazio · -52.3kt viveri
RISCALDAMENTO|100.0% sazio · -7.68kt legname
ABBIGLIAMENTO|31.3% sazio · -480.0t tessuti
CONSUMISMO|46.5% sazio · -1.43kt artigianato
Soddisfazione media nazionale|60.9%`,
 "Esercito":`Fanti|75
Cavalieri|30
Riservisti|1.58k
Paga data|0.3 milioni (100%)`
}),
sheet("Varïghå",["varigha","varïghå"],{
 "Quadro generale":`Abitanti|90.9k
Data|luglio -955
Stabilità|100.0 (0.0)
Denaro|104.1 milioni (+1.65 mln)
Tassazione|50.0%`,
 "Tecnologie":`Militare|1.84
Risorse|1.7
Industria|1.31
Logistica|2.0
Medica|1.51
Punti Progresso|61.37 (+3.1)
Ricerca|2.0457`,
 "Risorse":`Viveri|-135.0t (-134.0t)
Oro|0.83t (+0.04t)
Argento|26.3t (+1.35t)
Ferro|8.43kt (+186.0t)
Metalli|15.2kt (+446.0t)
Legname|152.0kt (+3.36kt)
Fibre tessili|11.0kt (+227.0t)
Rame|1.48kt (+32.6t)
Stagno|148.0t (+3.26t)
Sale|16.9kt (+510.0t)`,
 "Strutture":`Fattorie|1350/2632
Miniera d'oro|1/1
Miniera d'argento|1/2
Miniere di ferro|9/16
Miniere di metalli|5/7
Falegnamerie|13/42
Filaii|7/23
Miniere di rame|10/13
Miniere di stagno|10/20
Saline|8/75`,
 "Prodotti":`Tessuti|0.0t (+0.0t)
Armi|206.0t (+10.3t)
Artigianato|0.0t (+0.0t)
Bronzo|445.0t (+9.82t)
Ferro lavorato|805.0t (+17.8t)`,
 "Industrie":`Armerie|3
Industrie tessili|21
Botteghe artigianali|15
Fucine|7
Fonderie di bronzo|4
Costo Stocaggio|2.068mln`,
 "Infrastrutture e servizi":`Campi di addestramento|2 (9.0k/anno)
Cantieri navali|1 (1.31)
Arsenali|3 (3.93)
Capacità infrastrutture|59.6kt (80%)
Manodopera usata in totale|57.83%`,
 "Bisogni della popolazione":`SUSSISTENZA|72.3% sazio · -52.6kt viveri
RISCALDAMENTO|100.0% sazio · -6.84kt legname
ABBIGLIAMENTO|50.3% sazio · -688.0t tessuti
CONSUMISMO|50.3% sazio · -1.38kt artigianato
Soddisfazione media nazionale|68.2%`,
 "Esercito":`Fanti|130
Cavalieri|70
Riservisti|1.93k
Paga data|0.8 milioni (100%)`
}),
sheet("Kalaniti",["kalaniti"],{
 "Quadro generale":`Abitanti|97.6k
Data|luglio -955
Stabilità|100.0 (0.0)
Denaro|77.45 milioni (-0.71 mln)
Tassazione|27.0%`,
 "Tecnologie":`Militare|1.3
Risorse|1.6
Industria|1.5
Logistica|1.4
Medica|1.2
Punti Progresso|117.94 (+1.6)
Ricerca|1.3`,
 "Risorse":`Viveri|-87.0t (-86.1t)
Oro|2.9t (+0.08t)
Argento|178.0t (+4.58t)
Ferro|15.6kt (+344.0t)
Metalli|41.3kt (+908.0t)
Fibre tessili|19.9kt (+438.0t)
Rame|1.15kt (+25.2t)
Stagno|27.3t (+0.6t)
Sale|52.4kt (+1.15kt)`,
 "Strutture":`Fattorie|1150/1050
Miniera d'oro|2/2
Miniera d'argento|3/4
Miniere di ferro|14/18
Miniere di metalli|9/12
Falegnamerie|11/18
Filaii|8/10
Miniere di rame|12/14
Miniere di stagno|10/11
Saline|16/130`,
 "Prodotti":`Tessuti|0.0t (0)
Armi|2.43kt (+53.4t)
Artigianato|0.0t (0)
Bronzo|1.23kt (+27.0t)
Ferro lavorato|517.0t (+11.4t)`,
 "Industrie":`Armerie|7
Industrie tessili|14
Botteghe artigianali|18
Fucine|11
Fonderie di bronzo|6
Costo Stocaggio|1.348mln`,
 "Infrastrutture e servizi":`Campi di addestramento|3 (13.5k/anno)
Arsenali|2 (3.0)
Capacità infrastrutture|59.6kt (81%)
Manodopera usata in totale|50.38%`,
 "Bisogni della popolazione":`SUSSISTENZA|64.8% sazio · -50.6kt viveri
RISCALDAMENTO|69.0% sazio · -5.22kt legname
ABBIGLIAMENTO|34.7% sazio · -525.0t tessuti
CONSUMISMO|62.5% sazio · -1.89kt artigianato
Soddisfazione media nazionale|57.7%`,
 "Esercito":`Fanti|110
Cavalieri|45
Riservisti|1.4k
Paga data|0.5 milioni (100%)`
})
]};
export default nationSheetPayload;